import { createStore } from "vuex";
import themeLayout from "./modules/themeLayout/actionCreator";
import auth from "./modules/authentication/axios/actionCreator";
import administrator from "./modules/administrator/actionCreator";
import company from "./modules/company/actionCreator";
import editData from './modules/editData/actionCreator'
import glob from "./modules/glob/actionCreator";
import importExport from "../vuex/modules/importExport/actionCreator";
import candidates from "./modules/candidates/actionCreator";

export default createStore({
  modules: {
    themeLayout,
    auth,
    administrator,
    glob,
    editData,
    company,
    importExport,
    candidates,
  },
});
